import { useCallback, useMemo } from 'react';
import propTypes from 'prop-types';
import { Input } from 'reactstrap';
import { AsYouType } from 'libphonenumber-js';
import { byCountryCode } from '@kiper/fns';

const PhoneInput = ({ value, name, onChange, ...props }) => {
  const handlePhoneNumber = number => new AsYouType().input(number);

  const getLocationLanguage = language => {
    if (!language) return null;
    const [, countryCode] = language.split('-');
    return countryCode?.toUpperCase();
  };

  const locationLanguage = useMemo(() => {
    return getLocationLanguage(navigator?.language);
  }, [navigator?.language]);

  const handleChange = useCallback(
    event => {
      event.preventDefault();
      const { name: inputName, value: number } = event.target;
      const typedValue = handlePhoneNumber(number);
      if (!number.startsWith('+'))
        onChange(
          inputName,
          `${byCountryCode[locationLanguage]?.dialCode || '+55'}${typedValue}`,
        );
      else {
        onChange(inputName, typedValue);
      }
    },
    [onChange],
  );

  return (
    <Input
      {...props}
      value={value}
      onChange={handleChange}
      name={name}
      id={name}
    />
  );
};

export default PhoneInput;

PhoneInput.propTypes = {
  value: propTypes.string.isRequired,
  name: propTypes.string.isRequired,
  onChange: propTypes.func.isRequired,
};
